module.exports = __webpack_public_path__ + "static/media/Senior_Member_Resources.0a6a294b.md";